import {CodonTranslationTable} from 'biojs/BioConstants';

/** Keep in sync with ComponentSequenceType in benchling/antibodies/enforced_data_model/domain/schema_config.py. */
export enum DomainSequenceType {
  AA = 'AA',
  DNA = 'DNA',
}

export interface SequenceAnnotationConfig {
  sequenceType: DomainSequenceType;
  germlineId: string;
  /** Only set for DNA domain sequences. */
  geneticCode: CodonTranslationTable | null;
  /** Folder for the annotation results dataset. */
  folderId: string;
}

export enum AnnotationSubmitDecisionType {
  /**
   * Register without annotation: annotation is disabled for the tenant, the schema is not an AA or DNA domain
   * schema, or the user turned annotation off.
   */
  SKIP_ANNOTATION = 'SKIP_ANNOTATION',
  CANCEL = 'CANCEL',
  ANNOTATE = 'ANNOTATE',
}

export type AnnotationSubmitDecision =
  | {type: AnnotationSubmitDecisionType.SKIP_ANNOTATION}
  | {type: AnnotationSubmitDecisionType.CANCEL}
  | {
      type: AnnotationSubmitDecisionType.ANNOTATE;
      config: SequenceAnnotationConfig;
      /** Rows that were not yet registered when the user submitted, which are the only rows to annotate. */
      unregisteredRowIds: Array<string>;
    };
